import React, {useState, useContext} from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import MenuIcon from '@mui/icons-material/Menu'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import {SignInButton, SignInNavItem, SignOutButton, SignOutNavItem} from './auth/Auth'
import {AuthContext} from './auth/AuthContext'
import Button from '@mui/material/Button'
import {useLocation, useNavigate} from 'react-router-dom'
import NavItem from './NavItem'
import {useThemeMode} from './theme/AppThemeProvider'
import {ButtonBase, ToggleButton, ToggleButtonGroup} from '@mui/material'
import LightModeOutlined from '@mui/icons-material/LightModeOutlined'
import DarkModeOutlined from '@mui/icons-material/DarkModeOutlined'

const drawerWidth = 240
const appTitle = 'Fancy Timer'

const navigationItems = () => [
  {text: 'Payouts', path: '/payouts'},
  {text: 'Schedules', path: '/schedules'},
  ...(import.meta.env.VITE_ENABLE_SESSIONS === 'true' ? [{text: 'Sessions', path: '/sessions'}] : []),
]

const SignedInList = () => {
  const {pathname} = useLocation()
  const navigate = useNavigate()
  return (
    <List>
      {navigationItems().map(item => <NavItem key={item.path} text={item.text} selected={pathname.startsWith(item.path)} onClick={() => navigate(item.path)}/>)}
      <SignOutNavItem/>
    </List>
  )
}

function ResponsiveAppBar() {
  const {pathname} = useLocation()
  const {mode, setMode} = useThemeMode()
  const [mobileOpen, setMobileOpen] = useState(false)
  const {currentUser} = useContext(AuthContext)
  const navigate = useNavigate()

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState)
  }

  return (
    <>
      <AppBar component="nav" position="sticky">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component={ButtonBase}
            sx={{
              flexGrow: 1,
              display: 'block',
              fontSize: {xs: '1rem', sm: '1.7rem'},
              color: 'inherit', background: 'none', border: 0, textAlign: 'left',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
            aria-current={pathname === '/' ? 'page' : undefined}
            onClick={() => navigate('/')}
          >
            {appTitle}
          </Typography>
          <ToggleButtonGroup exclusive size="small" value={mode} aria-label="Color mode"
            onChange={(_, value) => {if (value) setMode(value)}} sx={{mx: 1}}>
            <ToggleButton value="light" aria-label="Light mode"><LightModeOutlined fontSize="small"/></ToggleButton>
            <ToggleButton value="dark" aria-label="Dark mode"><DarkModeOutlined fontSize="small"/></ToggleButton>
          </ToggleButtonGroup>
          {currentUser ?
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              {navigationItems().map(item => <Button key={item.path} color="inherit" aria-current={pathname.startsWith(item.path) ? 'page' : undefined}
                sx={{'&[aria-current="page"]': {color: 'primary.main', borderBottom: 2, borderRadius: 0}}} onClick={() => navigate(item.path)}>{item.text}</Button>)}
              <SignOutButton/>
            </Box> :
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <SignInButton/>
            </Box>
          }
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Typography component={ButtonBase} variant="h6" sx={{ my: 2, color: 'inherit', bgcolor: 'transparent', border: 0, cursor: 'pointer' }} onClick={() => navigate('/')}>
              {appTitle}
            </Typography>
            <Divider />
            {currentUser ? <SignedInList/> : <List><SignInNavItem/></List>}
          </Box>
        </Drawer>
      </nav>
    </>
  )
}

export default ResponsiveAppBar
